(function() {
    function init() {
        const storageKey = 'blox-recently-viewed';
        const maxStoredAssets = 10;
        
        // Extract data from data-recently-read attribute
        const dataElement = document.querySelector('[data-recently-read]');
        if (!dataElement) {
            console.warn('Cannot track recently read: data-recently-read attribute not found');
            return;
        }
        
        let asset;
        try {
            const jsonString = dataElement.getAttribute('data-recently-read');
            const data = JSON.parse(jsonString);
            asset = {
                id: data.uuid,
                title: data.title,
                url: data.url
            };
        } catch (e) {
            console.error('Failed to parse data-recently-read attribute:', e);
            return;
        }
        
        // Validate required data before proceeding
        if (!asset.id || !asset.title || !asset.url) {
            console.warn('Cannot track recently read: missing ID, title, or URL');
            return;
        }
        
        let assets = [];
        const stored = localStorage.getItem(storageKey);
        
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                assets = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                console.error('Failed to parse stored assets:', e);
            }
        }
        
        assets = assets.filter((existingAsset) => existingAsset.id !== asset.id);
        assets.unshift(asset);
        assets = assets.slice(0, maxStoredAssets);
        
        localStorage.setItem(storageKey, JSON.stringify(assets));
    }
        
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();